module.exports = __webpack_public_path__ + "img/1.18c5644e.png";